module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-BoldItalic-Cy-Web.2f19b9cd.woff";